import { ChangeDetectionStrategy, Component, OnDestroy, signal } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonV3Component, InputV3Component } from '@gea/digital-ui-lib';
import { DividerModule } from 'primeng/divider';
import { finalize, firstValueFrom, from, Subject, switchMap, takeUntil } from 'rxjs';
import { OAuthService } from '../../../shared/services/oauth.service';
import { DataMaintenanceService } from '../data-maintenance.service';
import { DevOpsCommitResponse } from '../data-maintenance.model';

@Component({
  selector: 'app-commit-dialog',
  imports: [InputV3Component, ReactiveFormsModule, ButtonV3Component, DividerModule],
  templateUrl: './commit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitDialogComponent implements OnDestroy {
  isLoading = signal(false);
  private destroy$ = new Subject<void>();
  commitForm = this.formBuilder.group({
    summary: new FormControl('', [Validators.required, Validators.minLength(5)]),
  });

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: DynamicDialogRef,
    private oAuthService: OAuthService,
    private dataMaintenanceService: DataMaintenanceService
  ) {}

  save(): void {
    if (this.commitForm.valid && this.commitForm.value.summary) {
      this.isLoading.set(true);
      from(this.oAuthService.getToken())
        .pipe(
          switchMap((token) => this.dataMaintenanceService.commitUserAssets(token, this.commitForm.value.summary ?? '')),
          takeUntil(this.destroy$),
          finalize(() => this.isLoading.set(false))
        )
        .subscribe({
          next: (commitResult: DevOpsCommitResponse) => {
            this.dialogRef.close(commitResult);
          },
          error: (err: any) => {
            console.log(err || 'Unable to submit the pending changes. Please try again.');
          },
        });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
